module.exports = __webpack_public_path__ + "assets/close.ffc9a88e.svg";